/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2018
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

const API_BASE = environment.apiUrl;

@Injectable({
  providedIn: 'root',
})
export class LicenseDiscountService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(`${API_BASE}licenseDiscounts`, {
      withCredentials: true,
    });
  }

  save(licenseDiscount: any): Observable<any> {
    return this.http.post(`${API_BASE}licenseDiscounts`, licenseDiscount, {
      withCredentials: true,
    });
  }

  remove(licenseDiscountId: string): Observable<any> {
    return this.http.delete(`${API_BASE}licenseDiscounts/${licenseDiscountId}`, {
      withCredentials: true,
    });
  }
}
